import { useCallback, useMemo } from "react";

import { useFleet } from "../FleetProvider";
import { useParams } from "react-router-dom";
import { useFleetNavigate } from "lib/hooks/useFleetNavigate";
import { useARCConnection } from "./useARCConnection";
import { ARCContext, useARC } from "./ARCContext";

// Re-export for backward compatibility
export { useARC, ARCContext };

const ARCProvider = ({ children }) => {
    const { ARCSerialNumber: serialInUrl } = useParams();
    const { arcsInfo } = useFleet();

    const navigate = useFleetNavigate();

    const selectARC = useCallback(
        (serial) => {
            navigate(`/control/${serial}`);
        },
        [navigate]
    );

    const selectedARC = useMemo(() => {
        return arcsInfo?.find((arc) => arc.serialNumber === serialInUrl) || null;
    }, [arcsInfo, serialInUrl]);

    const { controlSocket, connectionState, sendCommand, callService } = useARCConnection(selectedARC);

    return (
        <ARCContext.Provider
            value={{
                controlSocket,
                connectionState,
                sendCommand,
                callService,
                selectedARC,
                selectARC,
                selectedARCSerial: serialInUrl,
            }}
        >
            {children}
        </ARCContext.Provider>
    );
};

export default ARCProvider;
